import React, { useEffect, useState } from 'react';
import { ZiggeoRecorder } from 'react-ziggeo';
import { ZIGGEO_API_KEY } from 'src/config/common.constants';
import { useQueryParam } from 'src/hooks/useQueryParams';
import { sendVideoMailForMobile, GetDurationFromZiggeo } from 'src/services/video-mail.service';
import styled from 'styled-components';
import { useToast } from '../../../context/ToastContext';
import Button from '../../common/Button';

const StyledVideoRecorderBackPage = styled.div`
    overflow: hidden;
    .redirect {
        background-color: black;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        flex-direction: column;
    }
    .redirect-message {
        color: #00934a;
        background-color: black;
        font-weight: bold;
        font-size: 20px;
        margin-bottom: 100px;
        font-family: sans-serif !important;
    }
`;

const StyledVideoRecorder = styled.div`
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
`;

// const StyledLoader = styled.div`
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     top: 50%;
//     height: 800px;
// `;

const VideoRecorder = () => {
    const toast = useToast();
    const requestId = useQueryParam('requestId');
    const accessToken = useQueryParam('token');
    const deviceOS = useQueryParam('deviceOS');
    // const videoHeight = window.screen.height;

    // const videoWidth = useMemo(() => Math.min(window.innerWidth, window.innerHeight), []);

    // let videoWidth = window.screen.width;
    // const videoHeight = window.screen.height;
    //
    // if (window.devicePixelRatio < 1) {
    // videoWidth = window.screen.width / window.devicePixelRatio;
    // videoHeight = window.screen.height / window.devicePixelRatio;
    // }
    const handleRejectionEvent = (event: PromiseRejectionEvent) => {
        event.preventDefault();
    };
    const [redirectURL, setRedirectURL] = useState('');
    const [redirectURLFlag, setRedirectURLFlag] = useState(false);
    const [recorder, setRecorder] = useState<any>(null);
    const [videoToken, setVideoToken] = useState('');
    const [isVideoVerified, setIsVideoVerified] = useState(false);
    // const [loadingFlag, setLoadingFlag] = useState(true);

    const handleClose = (input: string) => {
        if (deviceOS?.toUpperCase() === 'IOS') {
            window.location.replace(input);
        } else if (deviceOS?.toUpperCase() === 'ANDROID') {
            window.close();
        } else {
            window.location.replace(input);
        }
    };

    const scrollToBottom = () => {
        window.scroll({
            // top: videoHeight,
            // left: 0,
            // behavior: 'smooth',
        });
    };

    useEffect(() => {
        setTimeout(() => {
            if (requestId) {
                scrollToBottom();
            }
        }, 1000);
    }, [requestId]);

    const redirectToMobile = (input: string) => {
        if (input) {
            setRedirectURL(input);
            setRedirectURLFlag(true);
            setTimeout(() => {
                handleClose(input);
            }, 2000);
        }
    };

    useEffect(() => {
        window.addEventListener('unhandledrejection', handleRejectionEvent);
        return () => {
            window.removeEventListener('unhandledrejection', handleRejectionEvent);
        };
    }, []);

    useEffect(() => {
        let videoTokenLocal: string = '';
        if (recorder && requestId) {
            recorder.on('verified', async () => {
                videoTokenLocal = recorder.get('video');
                setVideoToken(videoTokenLocal);
                toast.success('Please wait while we process your request');
            });
            recorder.on('processed', function () {
                setIsVideoVerified(true);
            });
        }
    }, [recorder]);

    const sendVideoMail = async (durationInMilliSeconds: number) => {
        if (accessToken && requestId) {
            const { error } = await sendVideoMailForMobile({
                requestId,
                videoToken,
                durationInMilliSeconds,
                accessToken,
            });
            if (error) {
                toast.error(error.message);
            } else {
                redirectToMobile(
                    `${process.env.REACT_APP_MOBILE_APP_SCHEME_ID}://toappredirect/videomail/success?requestId=${requestId}&videoToken=${videoToken}&durationInMilliSeconds=${durationInMilliSeconds}`,
                );
            }
        } else {
            redirectToMobile(
                `${process.env.REACT_APP_MOBILE_APP_SCHEME_ID}://toappredirect/videomail/success?requestId=${requestId}&videoToken=${videoToken}&durationInMilliSeconds=${durationInMilliSeconds}`,
            );
        }
    };

    useEffect(() => {
        if (isVideoVerified) {
            const duration = GetDurationFromZiggeo(videoToken);
            duration.then((data) => {
                const durationInMs = data.duration > 0 ? data.duration * 1000 : 0;
                sendVideoMail(durationInMs);
            });
        }
    }, [isVideoVerified]);

    const handleCameraError = () => {
        toast.error('Please check whether your device camera is working properly and try again');
    };

    const onCameraUnresponsive = () => {
        toast.error('Please check whether your device camera is working properly and try again');
    };

    return (
        <>
            {redirectURLFlag ? (
                <StyledVideoRecorderBackPage>
                    <div className="redirect">
                        <div className="redirect-message">
                            <span>Videomail sent successfully!</span>
                        </div>
                        <Button
                            style={{ fontFamily: 'sans-serif' }}
                            onClick={() => handleClose(redirectURL)}
                        >
                            Go back to app
                        </Button>
                    </div>
                </StyledVideoRecorderBackPage>
            ) : (
                <StyledVideoRecorder>
                    <ZiggeoRecorder
                        apiKey={ZIGGEO_API_KEY}
                        // height={`${videoHeight}px`}
                        // width={`${videoWidth}px`}
                        height="100vh"
                        width="min(100vw, 100vh)"
                        onRef={(ref: any) => setRecorder(ref)}
                        recordingwidth={640}
                        recordingheight={480}
                        allowrecord
                        allowupload={false}
                        theme="modern"
                        themecolor="blue"
                        picksnapshots={false}
                        pickcovershotframe="false"
                        skipinitial
                        skipinitialonrerecord
                        onCameraUnresponsive={onCameraUnresponsive}
                        onError={handleCameraError}
                        ziggeo-camerafacefront="true"
                        primaryrecord
                        webrtcstreaming
                        orientation="portrait"
                        media-orientation="portrait"
                        ziggeo-width="100%"
                        ziggeo-height="100%"
                        ziggeo-webrtcstreaming="true"
                    />
                </StyledVideoRecorder>
            )}
        </>
    );
};

export default VideoRecorder;
